"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importDefault(require("react"));
function ProgressBar(_a) {
    var { from, to, progress } = _a, props = __rest(_a, ["from", "to", "progress"]);
    return (react_1.default.createElement("div", { className: "flex flex-row w-full leading-none mt-3", "aria-hidden": true },
        react_1.default.createElement("div", { className: "shrink mr-2" },
            react_1.default.createElement("p", null, from)),
        react_1.default.createElement("div", { className: "grow flex items-center" },
            react_1.default.createElement("div", { className: "grow rounded-xl bg-gray-c relative overflow-hidden h-4 w-full translate-y-[2px]" },
                react_1.default.createElement("div", Object.assign({ className: "bg-green absolute top-0 bottom-0 left-0", style: {
                        width: `${progress}%`,
                    } }, props)))),
        react_1.default.createElement("div", { className: "shrink ml-2" },
            react_1.default.createElement("p", null, to))));
}
exports.ProgressBar = ProgressBar;
